import { useDispatch, useSelector } from 'react-redux'
import { Grid, makeStyles, TextField, useTheme } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import Paper from '@material-ui/core/Paper'
import { ContainerTitle } from '../common/container-title'
import Button from '@material-ui/core/Button'
import { TabPanel } from '../common/tab-pannel'
import { Panel } from '../common/panel'
import { ListeFonctions } from './ListeFonctions'
import { VariablesClient } from './variable-client/VariablesClient'
import { useHistory } from 'react-router-dom'
import { getFonctions, initFonctionsConfiguration } from '../../store/actions/fonction/fonction-action'
import { ParametresFonctions } from './parametre/ParametresFonctions'
import { VariablesContexte } from './variable-contexte/VariablesContexte'
import { dispatchActions } from '../../store/actions/common'
import { getAllReferentiels } from '../../store/actions/referentiel-action'
import { FONCTION_ENDPOINT } from '../../api/endpoints'
import { ImportExport } from './components/ImportExport'

const useStyles = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1),
  },
  contentRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  container: { maxWidth: '80%', overflowX: 'hidden', margin: 'auto', marginTop: 16, maxHeight: 500 },
  container2: { maxWidth: '80%', overflowX: 'hidden', margin: 'auto', marginTop: 16 },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  formControlPopper: {
    margin: 0,
    marginTop: 16,
    width: '100%',
  },
  popper: {
    ...theme.mixins.gutters(),
    minWidth: 380,
    maxWidth: 600,
    margin: 'auto',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}))

export const Fonctions = () => {
  const theme = useTheme()
  const history = useHistory()
  const loader = useSelector(state => state.loader)
  const fonctions = useSelector(state => state.fonctionModule.fonctions)
  const classes = useStyles()
  const [filterBy, setFilterBy] = useState('')

  const dispatch = useDispatch()

  useEffect(() => {
    dispatchActions(dispatch, initFonctionsConfiguration(), getAllReferentiels())
  }, [dispatch])

  return (
    <>
      <br />
      <br />
      {loader ? (
        <LinearProgress />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper className={classes.contentRoot} elevation={1}>
              <ContainerTitle variant="h6" classes={classes} title="Gestion des fonctions" />
            </Paper>
            <Grid container spacing={0} justify="center">
              <Grid item xs={10}>
                <Grid container spacing={0} justify="center">
                  <Grid container direction="row" justify="space-between" alignItems="flex-end">
                    <Grid item style={{ margin: 10 }}>
                      <TextField
                        label={'Filtrer'}
                        placeholder={'nom, description ou tags'}
                        size="small"
                        variant="outlined"
                        onChange={event => setFilterBy(event.target.value)}
                        margin="dense"
                        type="search"
                      />
                    </Grid>
                    <Grid item style={{ margin: 10 }}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="medium"
                        onClick={() => history.push('/fonction/create')}
                        className={classes.margin}
                      >
                        CRÉER UNE FONCTION
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    {!!fonctions.length && <ListeFonctions filterBy={filterBy} items={fonctions} />}
                  </Grid>
                  <ImportExport classes={classes} endpoint={FONCTION_ENDPOINT} reloadData={getFonctions} />
                </Grid>
              </Grid>
            </Grid>
            <br />
            <br />
          </Grid>
          <TabPanel titles={['Variables Client', 'Contexte', 'Paramètres Fonctions']}>
            <Panel value={1} index={1} dir={theme.direction}>
              <VariablesClient classes={classes} />
            </Panel>
            <Panel value={2} index={2} dir={theme.direction}>
              <VariablesContexte classes={classes} />
            </Panel>
            <Panel value={3} index={3} dir={theme.direction}>
              <ParametresFonctions classes={classes} />
            </Panel>
          </TabPanel>
        </Grid>
      )}
    </>
  )
}
